(function() {
if (customElements.get('wishlist-manager')) return;
class WishlistManager extends HTMLElement {
  constructor() {
    super();
    this.customerId = null;
    this.productIds = new Set();
    this.loaded = false;
    this._queue = Promise.resolve();
  }

  toProductGid(id) {
    var v = String(id || '').trim();
    if (!v) return '';
    if (v.startsWith('gid://')) return v;
    return 'gid://shopify/Product/' + v;
  }

  connectedCallback() {
    this.customerId = this.getAttribute('data-customer-id') || null;
    this.currency = this.getAttribute('data-currency') || 'USD';
    this.accountsWishlistUrl = this.getAttribute('data-accounts-wishlist-url') || 'https://account.teddybaldassarre.com/dashboard/wishlist';
    this.API_BASE = this.getAttribute('data-api-base') || 'https://teddy-baldassarre-git-hubspot-wishlist-cbe-teddy-baldassarre.vercel.app';
    this.signupSourceEmail = this.getAttribute('data-signup-source-email') || '';
    this.signupSourceSms = this.getAttribute('data-signup-source-sms') || '';

    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('main-product:variant-change', this.handleVariantChange.bind(this));
    // PDP variant refresh re-renders the add-to-cart block cold (no active class,
    // text back to "Add to Wishlist") — re-apply the saved state to the fresh markup.
    document.addEventListener('pdp:refreshed', this.renderAllStars.bind(this));

    this.initLoginModal();

    if (this.customerId) {
      this.fetchWishlist().then(function () {
        this.checkPendingIntent();
      }.bind(this));
    }
  }

  async fetchWishlist() {
    var cachedCustomer = sessionStorage.getItem('wishlist_customer');
    var cachedIds = sessionStorage.getItem('wishlist_ids');

    // Render from cache immediately if available
    if (cachedCustomer === this.customerId && cachedIds) {
      try {
        this.productIds = new Set(JSON.parse(cachedIds));
        this.loaded = true;
        this.renderAllStars();
        this.updateHeaderCount();
      } catch (e) {
        // Invalid cache, fall through to API
      }
    }

    // Always revalidate from server in background
    try {
      var resp = await fetch(this.API_BASE + '/api/wishlist/list?customerId=' + encodeURIComponent(this.customerId));
      if (!resp.ok) throw new Error('Server returned ' + resp.status);
      var data = await resp.json();
      var freshIds = new Set(data.wishlist);
      var changed = freshIds.size !== this.productIds.size || data.wishlist.some(function (id) { return !this.productIds.has(id); }.bind(this));
      if (changed) {
        this.productIds = freshIds;
        this.renderAllStars();
        this.updateHeaderCount();
      }
      this.loaded = true;
      sessionStorage.setItem('wishlist_ids', JSON.stringify(data.wishlist));
      sessionStorage.setItem('wishlist_customer', this.customerId);
    } catch (e) {
      console.error('[wishlist] fetch error:', e);
      this.loaded = true;
      this.renderAllStars();
      this.updateHeaderCount();
    }
  }

  toggle(productId, triggerEl) {
    if (!this.customerId) {
      this.showLoginModal(triggerEl);
      return;
    }

    var gid = this.toProductGid(productId);
    var wasInWishlist = this.productIds.has(gid);

    // Optimistic UI — instant, no waiting
    if (wasInWishlist) {
      this.productIds.delete(gid);
    } else {
      this.productIds.add(gid);
    }
    this.renderAllStars();
    this.updateHeaderCount();

    // Queue the API call so rapid clicks don't cause concurrent writes
    var self = this;
    this._queue = this._queue.then(function () {
      return self._sendToggle(gid, wasInWishlist, triggerEl);
    });
  }

  // Leaf - Custom Event - add_to_wishlist - Start
  _publishWishlistEvent(gid, triggerEl, meta) {
    try {
      if (!(window.Shopify && window.Shopify.analytics &&
            typeof window.Shopify.analytics.publish === 'function')) {
        return;
      }

      var productId = String(gid || '').replace(/^.*\//, '');
      var ctaEl = document.querySelector('[data-leaf-cta][data-leaf-product-id]');
      var pageCtaType = ctaEl ? ctaEl.getAttribute('data-leaf-cta') : '';
      var isPdp = !!ctaEl && ctaEl.getAttribute('data-leaf-product-id') === productId;
      // data-product-price is the raw Shopify variant price, which is in cents.
      var price = parseFloat(meta.price);
      if (!isNaN(price)) price = price / 100;

      window.Shopify.analytics.publish('leaf_product_added_to_wishlist', {
        product_id: productId,
        product_name: meta.productTitle || '',
        cta_type: pageCtaType || '',
        cta_location: isPdp ? 'detail' : 'list',
        item: {
          title: meta.productTitle || '',
          vendor: meta.vendor || '',
          // Mirrors Shopify's product.type, which Signal maps to item_category.
          type: ctaEl ? (ctaEl.getAttribute('data-leaf-product-type') || '') : '',
          images: [{ src: meta.imageUrl || '' }],
          variants: [{
            id: meta.variantId || '',
            product_id: productId,
            sku: meta.sku || '',
            price: isNaN(price) ? 0 : price,
            title: 'Default Title',
            vendor: meta.vendor || ''
          }]
        }
      });
    } catch (e) {
      // tracking must never break the wishlist flow
    }
  }
  // Leaf - Custom Event - add_to_wishlist - End

  _extractProductMeta(triggerEl) {
    var marketName = (window.__teddy || {}).marketName || null;
    if (!triggerEl) return { market: marketName };
    return {
      productTitle: triggerEl.getAttribute('data-product-title') || null,
      vendor: triggerEl.getAttribute('data-product-vendor') || null,
      sku: triggerEl.getAttribute('data-variant-sku') || null,
      price: triggerEl.getAttribute('data-product-price') || null,
      imageUrl: (triggerEl.getAttribute('data-product-image') || '').replace(/^\/\//, 'https://'),
      productUrl: triggerEl.getAttribute('data-product-url') || null,
      variantId: triggerEl.getAttribute('data-variant-id') || null,
      market: marketName
    };
  }

  async _sendToggle(gid, wasInWishlist, triggerEl) {
    try {
      var meta = this._extractProductMeta(triggerEl);
      var resp = await fetch(this.API_BASE + '/api/wishlist/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: this.customerId, productId: gid, ...meta })
      });
      if (!resp.ok) throw new Error('Server returned ' + resp.status);
      var data = await resp.json();
      sessionStorage.setItem('wishlist_ids', JSON.stringify(data.wishlist));

      // Leaf - Custom Event - add_to_wishlist - Start
      // Only on add, not on remove. cta_type describes the call to action the page was
      // showing rather than this button, because the wishlist star appears on every PDP -
      // keying it to itself would make its rate denominator the wishlist-primary
      // products only, and the rate could then exceed 100%.
      if (!wasInWishlist) {
        this._publishWishlistEvent(gid, triggerEl, meta);
      }
      // Leaf - Custom Event - add_to_wishlist - End
      sessionStorage.setItem('wishlist_customer', this.customerId);
      this.trackWishlistEvent(data.action, triggerEl, data.count);
      document.dispatchEvent(new CustomEvent('toast:show', {
        detail: {
          message: data.action === 'added' ? 'Added to wishlist' : 'Removed from wishlist',
          type: 'success'
        }
      }));
    } catch (e) {
      if (wasInWishlist) {
        this.productIds.add(gid);
      } else {
        this.productIds.delete(gid);
      }
      this.renderAllStars();
      this.updateHeaderCount();
      console.error('[wishlist] toggle error:', e);
    }
  }

  async moveFromCart(el) {
    if (!this.customerId) {
      this.showLoginModal(el);
      return;
    }

    var gid = this.toProductGid(el.getAttribute('data-wishlist-product-id'));
    var variantId = el.getAttribute('data-variant-id');
    var cartItem = el.closest('cart-item');
    var cart = document.querySelector('site-cart');

    // Show loading spinner
    if (cart && cartItem) cart.setItemLoading(cartItem);
    el.disabled = true;

    try {
      // 1. Add to wishlist
      var meta = this._extractProductMeta(el);
      var resp = await fetch(this.API_BASE + '/api/wishlist/move', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: this.customerId, productId: gid, ...meta })
      });
      if (!resp.ok) throw new Error('Server returned ' + resp.status);
      var data = await resp.json();

      this.productIds = new Set(data.wishlist);
      this.updateHeaderCount();
      sessionStorage.setItem('wishlist_ids', JSON.stringify(data.wishlist));
      sessionStorage.setItem('wishlist_customer', this.customerId);
      this.trackWishlistEvent('added', el, data.count);

      // 2. Remove from cart using variant ID (index-independent)
      if (cart && variantId) {
        var updates = {};
        updates[variantId] = 0;
        await cart.updateCart(updates);
      }
      this.renderAllStars();
      document.dispatchEvent(new CustomEvent('toast:show', {
        detail: { message: 'Moved to wishlist', type: 'success' }
      }));
    } catch (e) {
      console.error('[wishlist] move error:', e);
      el.disabled = false;
      if (cartItem) {
        var totals = cartItem.querySelector('.cart-item__totals');
        if (totals) {
          var priceEl = totals.firstElementChild;
          var loaderEl = totals.lastElementChild;
          if (priceEl) priceEl.classList.remove('hidden');
          if (loaderEl) loaderEl.classList.add('hidden');
        }
      }
    }
  }

  handleClick(e) {
    var toggle = e.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      this.toggle(toggle.getAttribute('data-wishlist-product-id'), toggle);
      return;
    }

    var move = e.target.closest('[data-wishlist-move-from-cart]');
    if (move) {
      e.preventDefault();
      this.moveFromCart(move);
      return;
    }

    var headerTrigger = e.target.closest('[data-wishlist-header-trigger]');
    if (headerTrigger) {
      this.handleHeaderClick();
      return;
    }
  }

  renderAllStars() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var gid = this.toProductGid(btn.getAttribute('data-wishlist-product-id'));
      var isActive = this.productIds.has(gid);
      btn.classList.toggle('wishlist-star--active', isActive);

      // Update PDP text if present
      var textEl = btn.querySelector('.wishlist-pdp-link__text');
      if (textEl) {
        textEl.textContent = isActive ? 'Added to Wishlist' : 'Add to Wishlist';
      }
    }

  }

  updateHeaderCount() {
    var countEls = document.querySelectorAll('[data-wishlist-count]');
    var count = this.productIds.size;
    for (var i = 0; i < countEls.length; i++) {
      countEls[i].textContent = count;
      countEls[i].classList.toggle('hidden', count === 0);
    }
  }

  handleVariantChange(e) {
    var variant = e.detail?.variant;
    if (!variant) return;
    var pdpBtns = document.querySelectorAll('[data-wishlist-toggle][data-source="PDP"]');
    for (var i = 0; i < pdpBtns.length; i++) {
      var pdpBtn = pdpBtns[i];
      pdpBtn.setAttribute('data-variant-id', variant.id);
      pdpBtn.setAttribute('data-variant-title', variant.title || '');
      if (variant.sku != null) {
        pdpBtn.setAttribute('data-variant-sku', variant.sku);
      }
      if (variant.price != null) {
        pdpBtn.setAttribute('data-product-price', variant.price);
      }
    }
  }

  initLoginModal() {
    var modalWrapper = document.querySelector('#wishlist-auth-modal');
    if (!modalWrapper) return;

    // Registration form submission
    var form = modalWrapper.querySelector('[data-wishlist-register-form]');
    var apiBase = this.API_BASE;
    var signupSourceEmail = this.signupSourceEmail;
    var signupSourceSms = this.signupSourceSms;
    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Creating...';
        }

        var firstName = form.querySelector('[name="first_name"]')?.value?.trim();
        var lastName = form.querySelector('[name="last_name"]')?.value?.trim();
        var email = form.querySelector('[name="email"]')?.value?.trim();
        var phoneInput = form.querySelector('[name="phone"]') || form.querySelector('input[type="tel"]');
        var phone = phoneInput?.value?.trim() || '';
        var smsConsentEl = form.querySelector('[name="sms_consent"]');
        var smsConsent = smsConsentEl ? smsConsentEl.checked : false;

        // Format phone via intl-tel-input if available
        var inputTelIntl = form.querySelector('input-tel-intl');
        if (inputTelIntl && phone) {
          try { phone = inputTelIntl.format(phone); } catch (e) { /* use raw value */ }
        }

        try {
          var resp = await fetch(apiBase + '/api/customer-with-tags', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              input: { firstName: firstName, lastName: lastName, email: email, phone: phone },
              tags: ['Wishlist Signup'],
              smsConsent: smsConsent,
              klaviyoSource: 'Wishlist Signup',
              signupSourceEmail: signupSourceEmail,
              signupSourceSms: signupSourceSms
            })
          });

          if (!resp.ok) throw new Error('Server returned ' + resp.status);

          // Redirect to login with email prefilled
          window.location.href = '/customer_authentication/login?login_hint=' + encodeURIComponent(email) + '&return_to=' + encodeURIComponent(window.location.pathname);
        } catch (err) {
          console.error('[wishlist] registration error:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Create Account';
          }
        }
      });
    }
  }

  showLoginModal(triggerEl) {
    var modalWrapper = document.querySelector('#wishlist-auth-modal');
    if (!modalWrapper) return;
    var modal = modalWrapper.querySelector('teddy-modal');
    if (!modal) return;

    // Set title and message based on context
    var titleEl = modalWrapper.querySelector('.modal__title .h3');
    var messageEl = modalWrapper.querySelector('[data-wishlist-login-message]');
    function buildLoginLink() {
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'js-wishlist-login-btn underline';
      a.textContent = 'Log In';
      return a;
    }

    if (triggerEl) {
      var productTitle = triggerEl.getAttribute('data-product-title');
      if (titleEl) titleEl.textContent = 'Save to Wishlist';
      if (messageEl) {
        messageEl.textContent = '';
        if (productTitle) {
          messageEl.append('To save ' + productTitle + ' to your wishlist, please ', buildLoginLink(), ' or create an account.');
        } else {
          messageEl.append('Create an account to start saving items to your wishlist, or please ', buildLoginLink(), '.');
        }
      }
    } else {
      if (titleEl) titleEl.textContent = 'View Your Wishlist';
      if (messageEl) {
        messageEl.textContent = '';
        messageEl.append('Please ', buildLoginLink(), ' or create an account to view your wishlist.');
      }
    }

    // Set login URL with return_to
    var loginBtn = modalWrapper.querySelector('.js-wishlist-login-btn');
    if (loginBtn) {
      if (triggerEl) {
        // Product context — return to current page to complete the action
        loginBtn.href = '/customer_authentication/login?return_to=' + encodeURIComponent(window.location.pathname);
      } else {
        // Header click — return to redirect page which sends them to accounts app wishlist
        loginBtn.href = '/customer_authentication/login?return_to=' + encodeURIComponent('/pages/redirect-to-members?redirect_path=/dashboard/wishlist');
      }
    }

    // Store intent if there's a product context
    if (triggerEl) {
      var productId = triggerEl.getAttribute('data-wishlist-product-id');
      if (productId) {
        var isMove = triggerEl.hasAttribute('data-wishlist-move-from-cart');
        var intent = {
          action: isMove ? 'move' : 'toggle',
          productId: this.toProductGid(productId)
        };
        if (isMove) {
          intent.variantId = triggerEl.getAttribute('data-variant-id');
        }
        sessionStorage.setItem('wishlist_pending', JSON.stringify(intent));
      }
    }

    modal.openModal(triggerEl);
  }

  handleHeaderClick() {
    if (this.customerId) {
      window.location.href = '/pages/redirect-to-members?redirect_path=/dashboard/wishlist';
    } else {
      this.showLoginModal(null);
    }
  }

  async checkPendingIntent() {
    var pending = sessionStorage.getItem('wishlist_pending');
    if (!pending) return;
    sessionStorage.removeItem('wishlist_pending');

    try {
      var intent = JSON.parse(pending);
      if (!intent.productId) return;

      if (intent.action === 'move') {
        // Add to wishlist
        var resp = await fetch(this.API_BASE + '/api/wishlist/move', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customerId: this.customerId, productId: intent.productId, market: (window.__teddy || {}).marketName || null })
        });
        if (resp.ok) {
          var data = await resp.json();
          this.productIds = new Set(data.wishlist);
          this.renderAllStars();
          this.updateHeaderCount();
          sessionStorage.setItem('wishlist_ids', JSON.stringify(data.wishlist));
          sessionStorage.setItem('wishlist_customer', this.customerId);
        }

        document.dispatchEvent(new CustomEvent('toast:show', {
          detail: { message: 'Added to wishlist', type: 'success' }
        }));

        // Remove from cart by finding the line index from the rendered HTML
        if (intent.variantId) {
          var moveBtn = document.querySelector('[data-wishlist-move-from-cart][data-variant-id="' + intent.variantId + '"]');
          if (moveBtn) {
            var lineIndex = moveBtn.getAttribute('data-line-item-index');
            var cart = document.querySelector('site-cart');
            if (cart && lineIndex) {
              await cart.updateQuantity(Number(lineIndex), 0, {});
            }
          }
        }
      } else {
        // Only add if not already in wishlist (avoid toggling off)
        if (!this.productIds.has(intent.productId)) {
          this.toggle(intent.productId, null);
        }
      }
    } catch (e) {
      console.error('[wishlist] pending intent error:', e);
    }
  }

  trackWishlistEvent(action, triggerEl, wishlistCount) {
    if (!triggerEl) return;
    if (!window.klaviyo || typeof window.klaviyo.track !== 'function') return;
    var eventName = action === 'added' ? 'Added to Wishlist' : 'Removed from Wishlist';
    var market = window.__teddy || {};
    var variantId = triggerEl.getAttribute('data-variant-id') || '';

    var props = {
      ProductName: triggerEl.getAttribute('data-product-title'),
      ProductID: triggerEl.getAttribute('data-wishlist-product-id'),
      VariantID: variantId || null,
      VariantName: triggerEl.getAttribute('data-variant-title') || null,
      Brand: triggerEl.getAttribute('data-product-vendor'),
      Price: parseFloat(triggerEl.getAttribute('data-product-price')) / 100,
      Currency: this.currency,
      ProductURL: window.location.origin + triggerEl.getAttribute('data-product-url'),
      ImageURL: (triggerEl.getAttribute('data-product-image') || '').replace(/^\/\//, 'https://'),
      ProductCategories: (triggerEl.getAttribute('data-product-tags') || '').split(',').filter(Boolean),
      Source: triggerEl.getAttribute('data-source'),
      WishlistCount: wishlistCount,
      unique_id: crypto.randomUUID(),
      Market: market.marketName || ''
    };

    if (variantId) {
      fetch(this.API_BASE + '/api/variant-inventory?variant=' + encodeURIComponent(variantId))
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.inventory) props.Inventory = data.inventory;
          window.klaviyo.track(eventName, props);
        })
        .catch(function() {
          window.klaviyo.track(eventName, props);
        });
    } else {
      window.klaviyo.track(eventName, props);
    }
  }
}

customElements.define('wishlist-manager', WishlistManager);
})();
